import { string, bool, func, object, oneOfType, number, array } from "prop-types";
import classnames from "classnames";

function Input({
  marginBottom,
  valid,
  label,
  isMediumFont,
  errorMessage,
  register,
  id,
  icon,
  elemRef,
  onBlurInput,
  autoComplete,
  className = "",
  ...props
}) {
  const {
    onChange: rhfOnChange,
    onBlur: rhfOnBlur,
    ref: rhfRef,
    name: rhfName,
  } = register && typeof register === "object" ? register : {};
  const inputClass = classnames(
    /* base */
    "flex w-full rounded-md border bg-background px-3 py-1.5 text-sm shadow-sm",
    "transition-colors duration-fast",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium",
    "placeholder:text-muted-foreground",
    /* focus */
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
    {
      /* normal state */
      "border-input-border": valid !== false,
      /* error state */
      "border-destructive text-destructive ring-destructive focus-visible:ring-destructive":
        valid === false,
      /* icon padding */
      "pl-10": icon,
      /* margin */
      [`mb-${marginBottom}`]: marginBottom,
      /* disabled */
      "bg-muted cursor-not-allowed opacity-60": props.disabled,
      [className]: className,
    }
  );

  const labelClass = classnames(
    "block text-sm font-medium leading-5 text-foreground mb-1.5",
    { "font-medium": isMediumFont }
  );

  const { onChange: parentOnChange, ...inputProps } = props;

  const handleBlurInput = (e) => {
    rhfOnBlur?.(e);
    onBlurInput(id, e.target.value, e);
  };

  const handleChange = (e) => {
    parentOnChange?.(e);
    rhfOnChange?.(e);
  };

  return (
    <div className="relative">
      {label && (
        <label htmlFor={id} className={labelClass}>
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <img
              className="h-4 w-4 text-muted-foreground"
              src={icon}
              alt=""
            />
          </div>
        )}
        <input
          id={id}
          className={inputClass}
          autoComplete={autoComplete || null}
          {...inputProps}
          name={rhfName || id}
          ref={rhfRef}
          onChange={handleChange}
          onBlur={handleBlurInput}
        />
        {valid === false && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <svg
              className="h-4 w-4 text-destructive"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}
      </div>
      {valid === false && errorMessage && (
        <p className="mt-1.5 text-xs text-destructive">{errorMessage}</p>
      )}
    </div>
  );
}

Input.propTypes = {
  isMediumFont: bool,
  id: string,
  valid: oneOfType([bool, array]),
  label: string,
  errorMessage: string,
  containerClass: string,
  register: oneOfType([func, object]),
  marginBottom: number,
  onBlurInput: func,
  className: string,
};

Input.defaultProps = {
  id: "",
  valid: true,
  label: "",
  errorMessage: "",
  register: () => {},
  onBlurInput: () => {},
};

export default Input;
